export enum StickyTabsEasyOnlineOrdering {
    CHOOSE = 'choose',
    ORDER = 'order',
    FINALISE = 'finalise'
};
